// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import cx from 'classnames';
// Components
import OMTitle from '../../components/OMComponents/OMTitle/OMTitle';
import withPageWrapper from '../../containers/PageContainer/PageContainer';
// Styles
import * as styles from '../PrivacyPolicyPage/PrivacyPolicyPage.scss';
// Helpers
import { shareUrl } from '../../constants';
import multiLanguageTags from '../../helpers/multiLanguageHeadTags';

class AboutUsPage extends Component {
  numberOfParenthesis = 7; // eslint-disable-line react/sort-comp
  mapReference = new Array(this.numberOfParenthesis - 1).fill(1);
  parenthesis = [];

  state = {
    texts: []
  };

  componentDidMount() {
    this.setParenthesis();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.locale && newProps.locale !== this.props.locale) {
      this.setParenthesis(newProps);
    }
  }

  setParenthesis = (props = this.props) => {
    const texts = this.parenthesis.map((paren, idx) => props.translate(`parenthesis.${idx + 1}`));
    this.setState({ texts });
  };

  addParenthesisRef = (ref) => {
    this.parenthesis.push(ref);
  };

  renderDiv = (index = 0) => (<div
    ref={this.addParenthesisRef}
    dangerouslySetInnerHTML={{ __html: this.state.texts[index] }}
  />);

  render() {
    const { route, location, locale, isNative } = this.props;
    const multiLanguage = multiLanguageTags(route, locale);

    return (
      <div className={cx(styles.main_block, 'pageHeight', { [styles.native]: isNative })}>
        <div className={styles.content}>
          <Helmet
            titleTemplate={this.props.staticTranslate('title', 'titleTemplate')()}
            title={this.props.staticTranslate('title', 'about')()}
            meta={[
              { property: 'og:url', content: `${shareUrl}${route}` },
              { property: 'og:title', content: `${this.props.title} | \u202BOnMap` },
              { property: 'og:description', content: this.props.staticTranslate('helmet', 'aboutDescription') },
              { name: 'description', content: this.props.staticTranslate('helmet', 'aboutDescription') },
              { property: 'x:title', content: `${this.props.title} | \u202BOnMap` },
              { property: 'x:description', content: this.props.staticTranslate('helmet', 'aboutDescription') },
              { property: 'x:image:alt', content: this.props.title }
            ]}
            link={[
              ...multiLanguage,
              { rel: 'canonical', href: `${shareUrl}${route}` }
            ]}
          />
          <div className={styles.aboutWrap}>

            { !this.props.isNative && (
              (<OMTitle className="pageTitle" title={this.props.title} />)
            ) }

            <div>{this.props.translate('1.1')}</div>
            {this.renderDiv()}
            <br />
            <ul className={styles.points}>
              {
                this.mapReference.map((item, index) =>
                  (<li key={index}>{this.renderDiv(index + 1)}</li>)) // eslint-disable-line react/no-array-index-key
              }
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

AboutUsPage.propTypes = {
  locale: PropTypes.string,
  translate: PropTypes.func,
  staticTranslate: PropTypes.func,
  title: PropTypes.func,
  route: PropTypes.any,
  isMobile: PropTypes.bool,
  location: PropTypes.object,
  isNative: PropTypes.bool
};

const mapStateToProps = ({ lang, native }) => ({
  title: getLang(lang, 'static', 'header', 'aboutUs'),
  staticTranslate: getLang(lang, 'static'),
  isNative: native.isNative,
  translate: getLang(lang, 'about')
});

export default connect(mapStateToProps)(withPageWrapper(AboutUsPage));
